import {AJAX_END} from '../../constants';

export type EndRequestAction = {
    /**
     * The action type
     */
    type : typeof AJAX_END;

    /**
     * The cancelFunction from CancelToken
     */
    cancelFn : Function;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid? : string;

    /**
     * The uid of the request itself
     */
    requestUid? : string;
}

/**
 * @memberOf! Actions
 *
 * @param {Function} cancelFn           The cancelFunction from CancelToken
 * @param {String} componentUid         The uid of the component the requests belongs to
 * @param {String} requestUid           The uid of the request itself
 *
 * @return {EndRequestAction}
 */
const endRequest = ( cancelFn : Function, componentUid? : string, requestUid? : string ) : EndRequestAction => {
    return {
        type: AJAX_END,
        cancelFn,
        componentUid,
        requestUid
    };
}
export type EndRequest = typeof endRequest;

export default endRequest;
